const POPUP_BOTTOM_HEIGHT = 42;
const POPUP_TOP_HEIGHT = 30;
const POPUP_MARGINS = 18;

export { POPUP_BOTTOM_HEIGHT, POPUP_TOP_HEIGHT, POPUP_MARGINS };
